<button [matMenuTriggerFor]="menu" class="custom-date-picker py-4 mt-0 rounded-4" mat-stroked-button >{{ 'days' | translate}}</button>

<mat-menu #menu="matMenu">
  <button (click)="generateDateRange(1)" mat-menu-item>{{'one-days' | translate}}</button>
  <button (click)="generateDateRange(7)" mat-menu-item>{{'last-seven-days' | translate}}</button>
  <button (click)="generateDateRange(14)" mat-menu-item>{{ '14-days' | translate}}</button>

  <mat-divider></mat-divider>

  <button (click)="generateDateRange(30)" mat-menu-item>{{ 'last-one-month' | translate}}</button>
  <button (click)="generateDateRange(90)" mat-menu-item>{{ 'last-three-month' | translate}}</button>

  <mat-divider></mat-divider>
  <button (click)="generateDateRange(365)" mat-menu-item>{{ 'last-one-year' | translate}}</button>
  <button (click)="generateDateRange(1825)" mat-menu-item>{{ 'last-five-year' | translate}}</button>
  <button [matMenuTriggerFor]="dateRangeMenu" mat-menu-item> {{ 'custom-date-range' | translate}} </button>
</mat-menu>

<mat-menu #dateRangeMenu="matMenu" class="px-3">

  <mat-form-field appearance="outline" class="">
    <mat-label>{{ label | translate }}</mat-label>
    <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
      <input formControlName="start" matStartDate placeholder="{{'start-date' | translate}}">
      <input formControlName="end" matEndDate placeholder="{{'end-date' | translate}}">
    </mat-date-range-input>
    <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>

    @if (range.controls.start.hasError('matStartDateInvalid')) {
      <mat-error>{{'invalid-start-date' | translate}}</mat-error>
    }
    @if (range.controls.end.hasError('matEndDateInvalid')) {
      <mat-error>{{'invalid-end-date' | translate}}</mat-error>
    }
  </mat-form-field>
</mat-menu>

